import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges,} from '@angular/core';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener,} from '@angular/material/tree';
import {SelectionModel} from '@angular/cdk/collections';
import {AppTranslateService} from '../../../../../../modules/services/translate/app-translate.service';
import {isSomeInputsChanged} from '../../../../../../utils/ng-changes';
import {EPConsor} from '../../../../../../domain/groupement/BidClsConsor';
import {GroupementService} from '../../../../../../modules/services/fournisseur/actedegroupement/groupement.service';

@Component({
    selector: 'app-tree-acte-groupement-table',
    templateUrl: './tree-acte-groupement-table.component.html',
    styleUrls: ['./tree-acte-groupement-table.component.css'],
})
export class TreeActeGroupementTableComponent implements OnInit {
    @Input() listchecked = [];
    @Output() dataselected = new EventEmitter<any>();
    selection = new SelectionModel<any>(true, []);
    checklistSelection = new SelectionModel<any>(true /* multiple */);
    @Input() body: EPConsor;
    list: any;
    private transformer = (node: any, level: number) => {
        return {
            expandable: !!node.listLocalArticle && node.listLocalArticle.length > 0,
            bidCls: node.bidCls,
            bidNo: node.bidNo,
            bidClsDtlDesc: node.bidClsDtlDesc,
            bidClsNm : node.bidClsNm ,
            idCls: node.idCls,
            idParent: node.idParent,
            guaranteeAmountCurr: node.guaranteeAmountCurr,
            budgetAmt: node.budgetAmt,
            budgetAmtCurr: node.budgetAmtCurr,
            bidModSeq: node.bidModSeq,
            ardExistConsor: node.ardExistConsor,
            approvedChef: node.approvedChef,
            ardExistConsorMem: node.ardExistConsorMem,
            affCheck: node.affCheck,
            epBidTypEval: node.epBidTypEval,
            islot: node.islot,

            level: level,
        };
    };

    treeFlattener = new MatTreeFlattener(
        this.transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.listLocalArticle
    );
    treeControl = new FlatTreeControl<any>(
        (node) => node.level,
        (node) => node.expandable
    );
    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    parent: string[] = ['bidCls'];
    displayedColumns: string[] = [
        'bidClsNm',
        'epBidTypEval',
        'envoi',
        /*    "spShopMulCls",
        "budgetAmtCurrF",*/
    ];
    readColumns: string[] = ['bidCls', 'bidClsNm', 'epBidTypEval', 'envoi'];
    labels: Partial<Record<any, string>> = {
        bidCls: 'bidCls',
        epBidTypEval: 'Type Evaluation',
        bidClsNm: 'bidClsDtlDesc',
        envoi: 'Envoi',
        /*    spShopMulCls: "Cautionnement",
        budgetAmtCurrF: "Estimation",*!/*/
    };
    show: boolean;
    /* Checks all the parents when a leaf node is selected/unselected */
    @Input() withcheckbok = true;

    constructor(
        private groupementservice: GroupementService,
        private appTranslateService: AppTranslateService
    ) {
    }

    getLevel = (node: any) => node.level;

    ngOnChanges(changes: SimpleChanges): void {
        if (isSomeInputsChanged(changes, ['body'])) {
            this.getdata();
        }
    }

    getcoulum() {
        return this.displayedColumns.filter((x) => x != 'envoi');
    }

    ngOnInit(): void {
        /*    //this.getcoulum();
        this.readColumns = [...this.parent, ...this.displayedColumns];*/
    }

    getlangue() {
        return this.appTranslateService.getDefaultLang();
    }

    getdir() {
        return this.appTranslateService.getDir();
    }

    getdata() {
        const data = new EPConsor();

        this.groupementservice
            .getlistlot(this.body)

            .subscribe(
                (value) => {
                    this.list = value;

                    this.list.filter((t) => {
                        if (t.epBidTypEval == 1) {
                            t.epBidTypEval = 'Lot';
                            t.listLocalArticle?.filter((x) => (x.islot = 'islot'));
                        }
                        if (t.epBidTypEval == 2) {
                            t.epBidTypEval = 'Article';
                            t.listLocalArticle?.filter((x) => (x.islot = 'isnolot'));
                            /*     t.listLocalArticle?.filter((a) => {
                              if (a.  "vConsorApply",
                    "ListLots" == 1) {
                                t.ardExistConsor = 1;
                              }
                              if ((a.ardExistConsorMem = 1)) {
                                t.ardExistConsorMem = 1;
                              }
                            });*/
                        }
                    });
                    this.list.sort(function(a, b) {
                        return a.bidCls - b.bidCls;
                    });
                    this.dataSource.data = this.list;

                },
                (error) => {
                }
            );
    }

    getParentNode(node: any): any | null {
        const currentLevel = this.getLevel(node);

        if (currentLevel < 1) {
            return null;
        }

        const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

        for (let i = startIndex; i >= 0; i--) {
            const currentNode = this.treeControl.dataNodes[i];

            if (this.getLevel(currentNode) < currentLevel) {
                return currentNode;
            }
        }
        return null;
    }

    todoLeafItemSelectionToggle(node: any): void {
        this.checklistSelection.toggle(node);
        this.checkAllParentsSelection(node);
        this.dataselected.emit(this.checklistSelection.selected);
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    descendantsAllSelected(node: any): boolean {
        const descendants = this.treeControl.getDescendants(node);
        return descendants.every((child) =>
            this.checklistSelection.isSelected(child)
        );
    }

    descendantsPartiallySelected(node: any): boolean {
        const descendants = this.treeControl.getDescendants(node);
        const result = descendants.some((child) =>
            this.checklistSelection.isSelected(child)
        );

        return result && !this.descendantsAllSelected(node);
    }

    todoItemSelectionToggle(node: any): void {
        this.checklistSelection.toggle(node);
        const descendants = this.treeControl.getDescendants(node);
        this.checklistSelection.isSelected(node)
            ? this.checklistSelection.select(...descendants)
            : this.checklistSelection.deselect(...descendants);

        // Force update for the parent
        descendants.forEach((child) => this.checklistSelection.isSelected(child));
        this.checkAllParentsSelection(node);
        this.dataselected.emit(this.checklistSelection.selected);
    }

    checkAllParentsSelection(node: any): void {
        let parent: any | null = this.getParentNode(node);
        while (parent) {
            this.checkRootNodeSelection(parent);
            parent = this.getParentNode(parent);
        }
    }

    /** Check root node checked state and change it accordingly */
    checkRootNodeSelection(node: any): void {
        const nodeSelected = this.checklistSelection.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        const descAllSelected = descendants.every((child) =>
            this.checklistSelection.isSelected(child)
        );
        if (nodeSelected && !descAllSelected) {
            this.checklistSelection.deselect(node);
        } else if (!nodeSelected && descAllSelected) {
            this.checklistSelection.select(node);
        }
    }

    getmsg(result) {
        if (result.approvedChef != '0' && result.ardExistConsor == '1') {
            return 'msgChef_Nosubmit_complete';
        } else if (result?.approvedChef == '0' && result?.ardExistConsor == '1') {
            return 'msgChef_submit_complete';
        } else if (
            result?.ardExistConsorMem == '1' &&
            result?.ardExistConsor != '1'
        ) {
            return 'msgMem_Nosubmit_complete';
        } else {
            return "";
        }
    }


}
